export const saGlobalReleaseConstants = {
  SA_GLOBAL_RELEASE_LOADING: "SA_GLOBAL_RELEASE_LOADING",
  SA_GLOBAL_RELEASE_SUCCESS: "SA_GLOBAL_RELEASE_SUCCESS",
  SA_GLOBAL_RELEASE_FAILURE: "SA_GLOBAL_RELEASE_FAILURE",
};

export const addSaGlobalReleaseConstants = {
  ADD_SA_GLOBAL_RELEASE_LOADING: "ADD_SA_GLOBAL_RELEASE_LOADING",
  ADD_SA_GLOBAL_RELEASE_SUCCESS: "ADD_SA_GLOBAL_RELEASE_SUCCESS",
  ADD_SA_GLOBAL_RELEASE_FAILURE: "ADD_SA_GLOBAL_RELEASE_FAILURE",
};

export const editSaGlobalReleaseConstants = {
  EDIT_SA_GLOBAL_RELEASE_LOADING: "EDIT_SA_GLOBAL_RELEASE_LOADING",
  EDIT_SA_GLOBAL_RELEASE_SUCCESS: "EDIT_SA_GLOBAL_RELEASE_SUCCESS",
  EDIT_SA_GLOBAL_RELEASE_FAILURE: "EDIT_SA_GLOBAL_RELEASE_FAILURE",
};
